import { IUserActions, UserActions } from "../actions/user.action";
import {
  IUserBusinessDto,
  IUserDto,
  IUserFiltersDto,
} from "../../interfaces/dto/user.dto";
import { IPagination } from "../../interfaces/default";
import { offsetToPage } from "../../utils/offsetToPage";

export interface IUserState {
  business: {
    isLoading: boolean;
    data?: IUserBusinessDto;
    error?: string;
  };
  info: {
    isLoading: boolean;
    data?: IUserDto;
    error?: string;
  };
  list: {
    isLoading: boolean;
    data?: Array<IUserDto>;
    pagination?: IPagination;
    error?: string;
    filters?: IUserFiltersDto;
  };
}

const initialState = {
  business: {
    isLoading: false,
  },
  info: {
    isLoading: false,
  },
  list: {
    isLoading: false,
  },
};

export const userReducer = (
  state = initialState,
  action: IUserActions,
): IUserState => {
  switch (action.type) {
    case UserActions.USER_UPDATE_BUSINESS:
      return {
        ...state,
        business: {
          ...state.business,
          isLoading: true,
        },
      };
    case UserActions.USER_BUSINESS:
      return {
        ...state,
        business: {
          isLoading: true,
          error: undefined,
          data: undefined,
        },
      };
    case UserActions.USER_BUSINESS_SUCCESS:
      return {
        ...state,
        business: {
          isLoading: false,
          error: undefined,
          data: action.payload,
        },
      };
    case UserActions.USER_BUSINESS_FAILURE:
      return {
        ...state,
        business: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
        },
      };
    case UserActions.USER_GET_LIST:
      return {
        ...state,
        list: {
          isLoading: true,
          error: undefined,
          data: undefined,
          pagination: undefined,
        },
      };
    case UserActions.USER_GET_LIST_SUCCESS:
      return {
        ...state,
        list: {
          isLoading: false,
          error: undefined,
          data: action.payload.data,
          pagination: {
            ...action.payload.pagination,
            page:
              offsetToPage(
                action.payload.pagination?.offset ?? 0,
                action.payload.pagination?.limit ?? 0,
              ) ?? 1,
          },
        },
      };
    case UserActions.USER_GET_LIST_FAILURE:
      return {
        ...state,
        list: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
          pagination: undefined,
        },
      };
    case UserActions.USER_GET_INFO:
      return {
        ...state,
        info: {
          isLoading: true,
          error: undefined,
          data: undefined,
        },
      };
    case UserActions.USER_GET_INFO_SUCCESS:
      return {
        ...state,
        info: {
          isLoading: false,
          error: undefined,
          data: action.payload,
        },
      };
    case UserActions.USER_GET_INFO_FAILURE:
      return {
        ...state,
        info: {
          isLoading: false,
          error: action.payload.error,
          data: undefined,
        },
      };
    case UserActions.USER_SET_LIST_FILTERS:
      return {
        ...state,
        list: {
          ...state.list,
          filters: action.payload,
        },
      };
    default:
      return state;
  }
};
